import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=311c70fc&scoped=true"
import script from "./Links.vue?vue&type=script&setup=true&lang=js"
export * from "./Links.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Links.vue?vue&type=style&index=0&id=311c70fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c70fc",
  null
  
)

export default component.exports